import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";
import CUSTOM_PARAMETERS from "./CUSTOM_PARAMETERS";

  function getPropertyMessageTranslation(){
    var onsiteConfiguration = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
    return (onsiteConfiguration && onsiteConfiguration.propertyMessages) || {};
  }

  function getDefaultLanguageFromPropertyData(){
    var propertyMessageData = getPropertyMessageTranslation();
    return KAMPYLE_UTILS.getNestedPropertyValue(propertyMessageData, 'localizationSettings.defaultLanguage');
  }

  function getLanguageCodeByCustomParam(){
    var propertyMessageData = getPropertyMessageTranslation();
    var customParamObject = KAMPYLE_UTILS.getNestedPropertyValue(propertyMessageData, 'localizationSettings.customParam');
    return CUSTOM_PARAMETERS.getCustomParamValue({
      type: customParamObject.type,
      name: customParamObject.source_name,
      source: customParamObject.source
    }) || getDefaultLanguageFromPropertyData();
  }

  function getPropertyMessageLanguageCode(){
    var propertyMessageData = getPropertyMessageTranslation();
    var shouldUseCustomParam = KAMPYLE_UTILS.getNestedPropertyValue(propertyMessageData, 'localizationSettings.useCustomParam');
    if(shouldUseCustomParam){
      return getLanguageCodeByCustomParam();
    }
    else{
      return KAMPYLE_UTILS.getLangCodeFromNavAPI();
    }
  }
  
  function getMessageByTypeAndKey(type, key){
    var propertyMessageData = getPropertyMessageTranslation().messagesData || {};
    var propertyMessageLangCode = KAMPYLE_UTILS.safeToLower(getPropertyMessageLanguageCode());
    var messageObjectByLanguage = propertyMessageData[type] && propertyMessageData[type][propertyMessageLangCode];
    if(messageObjectByLanguage && messageObjectByLanguage[key] != undefined){
      return messageObjectByLanguage[key];
    }
    else{
      var defaultLanguageCode = KAMPYLE_UTILS.safeToLower(getDefaultLanguageFromPropertyData());
      var messageObjectByDefaultLanguage = propertyMessageData[type] && propertyMessageData[type][defaultLanguageCode];
      if(messageObjectByDefaultLanguage && messageObjectByDefaultLanguage[key] != undefined){
        return messageObjectByDefaultLanguage[key]
      }
      return KAMPYLE_CONSTANT.TEXTS.DEFAULT_JSON_ERROR_MESSAGES[key];
    }
  }

  export default {
    getPropertyMessageLanguageCode: getPropertyMessageLanguageCode,
    getPropertyMessageTranslation: getPropertyMessageTranslation,
    getDefaultLanguageFromPropertyData: getDefaultLanguageFromPropertyData,
    getLanguageCodeByCustomParam: getLanguageCodeByCustomParam,
    getMessageByTypeAndKey: getMessageByTypeAndKey
  }